import { render, staticRenderFns } from "./KlentsCard.vue?vue&type=template&id=43280cd6&"
import script from "./KlentsCard.vue?vue&type=script&lang=js&"
export * from "./KlentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports